// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NrYh","rightAdornment":"Header_rightAdornment__2JG6_"};